/* eslint-disable react-hooks/exhaustive-deps */
import React from "react"
import {useTranslation} from "react-i18next"
import {BaseButton} from "components"
import Filters from "./parts/Filters"
import StatisticCards from "./parts/StatisticCards"
import RefundTable from "./parts/RefundTable"
import styles from "./RefundTab.module.css"
import {routing} from "helpers/routing"
import {useHistory} from "react-router-dom"

interface RefundTabProps {}

const RefundTab: React.FC<RefundTabProps> = () => {
    const {t} = useTranslation(["financialAid", "common"])
    const history = useHistory()

    const handleClickRefund = React.useCallback(() => {
        history.push(routing.finAid.student.refundDetail(1, "new"))
    }, [])

    return (
        <div>
            <Filters />
            <StatisticCards />

            <div className={styles.actionWrap}>
                <BaseButton
                    title={t("refund.label.addRefund")}
                    onClick={handleClickRefund}
                    className={styles.addButton}
                />
            </div>

            <RefundTable />
        </div>
    )
}

export default RefundTab
